import { Button, Divider, DrawerBody, DrawerHeader, Text } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DrawerFixedButton } from 'components/Drawer';
import EmployeeInfiniteList from 'components/InfiniteScroll/EmployeeInfiniteList';
import JobsInfiniteList from 'components/InfiniteScroll/JobsInfiniteList';
import { useBulkAssignJobs } from 'hooks/jobs/useBulkAssignJobs';

import { initialMassJobsFormData, massJobsFormValidationSchema, IInitialMassJobsFormData } from './schema';

interface IAddGroupProps {
  onClose?: () => void;
  initialJobs?: any[];
}

const MassJobs: React.FC<IAddGroupProps> = ({ onClose, initialJobs = [] }) => {
  const { t } = useTranslation(['jobsTasks', 'common']);

  const { status, mutateAsync } = useBulkAssignJobs();
  const [initialMassJobsData, setInitialMassJobsData] = useState<IInitialMassJobsFormData>(initialMassJobsFormData);

  useEffect(() => {
    const newJobsData: IInitialMassJobsFormData = { ...initialMassJobsFormData, job_ids: initialJobs };
    setInitialMassJobsData(newJobsData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFormSubmit = async (values: IInitialMassJobsFormData) => {
    const postData = {
      all_users: values.all_users,
      user_ids: values.user_ids.length ? values.user_ids.map((item: any) => item.userId) : [],
      job_ids: values.job_ids.length ? values.job_ids.map((item: any) => item.id) : [],
    };

    mutateAsync(postData).then(() => {
      if (onClose) {
        onClose();
      }
    });
  };

  return (
    <>
      <DrawerHeader>{t('jobsTasks:massAssignJobs')}</DrawerHeader>
      <DrawerBody>
        <Divider mb="6" />
        <Formik
          initialValues={initialMassJobsData}
          validationSchema={massJobsFormValidationSchema}
          onSubmit={handleFormSubmit}
          enableReinitialize
        >
          {() => (
            <Form noValidate>
              <Text as="h4" textTransform="uppercase" size="md" fontWeight="semibold" mb="2">
                {t('common:jobs')}
              </Text>
              <JobsInfiniteList boxHeight="calc(50vh - 215px)" />
              <Divider my="6" />
              <Text as="h4" textTransform="uppercase" size="md" fontWeight="semibold" mb="2">
                {t('common:employees')}
              </Text>
              <EmployeeInfiniteList boxHeight="calc(50vh - 215px)" />
              <DrawerFixedButton>
                <Button type="submit" colorScheme="secondary" width="100%" size="lg" isLoading={status === 'loading'}>
                  {t('jobsTasks:massAssign')}
                </Button>
              </DrawerFixedButton>
            </Form>
          )}
        </Formik>
      </DrawerBody>
    </>
  );
};

export default MassJobs;
